<template>
	<v-dialog v-model="visibleIncreasePriceModal" max-width="480px">

		<template v-slot:activator="{ on, attrs }">
			<v-btn color="teal white-text uppercase" large v-bind="attrs" v-on="on">
				Modifica preturile %
			</v-btn>
		</template>

		<v-card>
			<v-card-title class="text-h5">Modifica preturile %</v-card-title>
			<v-form ref="increasePriceForm" v-model="validIncreasePriceForm" @submit.prevent="savePrices">
				<v-card-text class="p-4">
					<v-alert type="warning" dense outlined>
						{{ selectedModels.length
							? `Se vor modifica preturile pentru ${selectedModels.length} model${selectedModels.length > 1 ?
								'e' :
								''} selectat${selectedModels.length > 1 ? 'e' : ''}`
							: 'Se vor modifica toate preturile din tabel' }}
					</v-alert>
					<div v-if="models.length" class="mb-4">
						<p class="text-base font-bold mb-2">Selectati modelele (optional):</p>
						<v-select v-model="selectedModels" :items="models" :item-text="itemTextField" item-value="id_model"
							multiple outlined clearable hide-details label="Toate modelele" chips
							small-chips></v-select>
					</div>
					<p class="text-base font-bold mt-4">Introduceti procentul de modificare a preturilor:</p>
					<v-text-field v-model="percent" class="w-1/2" outlined label="Procent" type="number" suffix="%"
						:rules="[rules.required, rules.percent]" required></v-text-field>
				</v-card-text>
				<div class="flex justify-end gap-2 p-4">
					<v-btn @click="cancel" class="uppercase">Anuleaza</v-btn>
					<v-btn type="submit" color="teal" class="uppercase white--text">Salveaza</v-btn>
				</div>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	name: "IncreasePrices",
	props: {
		country: String,
		priceType: String,
		models: {
			type: Array,
			default: () => []
		},
		itemTextField: {
			type: String,
			default: 'model_name'
		}
	},
	data() {
		return {
			visibleIncreasePriceModal: false,
			validIncreasePriceForm: false,
			percent: null,
			selectedModels: [],
			rules: {
				required: value => !!value || 'Câmp obligatoriu',
				percent: value => !value || /^-?[1-9]\d*$/.test(value) || 'Valoare invalida',
			}
		};
	},
	methods: {
		...mapActions('fencePrices', ["updateAllFencePrices"]),
		cancel() {
			this.visibleIncreasePriceModal = false
			this.$nextTick(() => {
				this.percent = null
				this.selectedModels = []
			})
		},
		async savePrices() {
			const valid = await this.$refs.increasePriceForm.validate();

			if (valid) {
				const newPrices = {
					priceType: this.priceType,
					country: this.country,
					percent: this.percent,
					models: this.selectedModels.length ? this.selectedModels : null
				}
				this.updateAllFencePrices(newPrices)
				this.visibleIncreasePriceModal = false
				this.$nextTick(() => {
					this.percent = null
					this.selectedModels = []
				})
			}
		}
	}

};
</script>

<style scoped></style>
